<template>
  <div v-if="hasPermission">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'SGPPermissionamentoComponent',
  
  props: {
    rota: {
      type: String,
      required: true
    }
  },

  computed: {
    hasPermission () {
      return this.$permissionamento.possuiPermissao(this.rota)
    }
  }


}
</script>